/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StringApiRespModel } from '../../models/string-api-resp-model';

export interface ApiMasterCourseDeleteGet$Params {
  id?: string;
}

export function apiMasterCourseDeleteGet(http: HttpClient, rootUrl: string, params?: ApiMasterCourseDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCourseDeleteGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StringApiRespModel>;
    })
  );
}

apiMasterCourseDeleteGet.PATH = '/api/Master/Course/Delete';
